module.exports = __webpack_public_path__ + "img/logo-small.dcb934cb.svg";